export default {
  "sandbox.list.head.title": "SANDBOX",
  "sandbox.list.head.description":
    "LINK-J Sandboxは、様々な背景を持つ学生・若者が集まり、協働しながら『何か』を創り出していく場です。砂場遊びのように、自由に創っては壊すを繰り返しながら、次世代のイノベーションに繋がる議論やアイディアが生まれる場であってほしい、そんな思いからSandboxすなわち「砂場」というタイトルをつけています。",
  "sandbox.list.head.siteName": "LINK-J",
  "sandbox.list.title": "SANDBOX",
  "sandbox.list.heading.title": "SANDBOX",
  "sandbox.list.lead1":
    '"LINK-J Sandbox"は、様々な背景を持つ学生・若者が集まり、協働しながら『何か』を創り出していく場です。',
  "sandbox.list.lead2":
    "砂場遊びのように、自由に創っては壊すを繰り返しながら、次世代のイノベーションに繋がる議論やアイディアが生まれる場であってほしい、",
  "sandbox.list.lead3":
    'そんな思いから "Sandbox" すなわち「砂場」というタイトルをつけています。',
  "sandbox.list.lead4":
    '"SCOOP"は、"SANDBOX Co-operative Project"の頭文字を取ったもので、「砂場」で使う「スコップ」をモチーフにしています。',
  "sandbox.list.lead5":
    "様々な分野の学生・若者が集った場に、楽しく創造するための道具・手段を提供するという思いが込められています。 このプロジェクトで、異分野の学生・若者がチームを組み、自ら企画してライフサイエンス分野の課題に取り組むことを通して、試行錯誤や、成功体験を得て飛躍することを目的としています。",
  "sandbox.list.index.breadcrumbs": "SANDBOX一覧",

  "sandbox.categories.scoop": "SCOOP",
  "sandbox.categories.link-j-sandbox": "SANDBOX",
  "sandbox.categories.index": "SANDBOX一覧",

  "sandbox.detail.head.siteName": "SANDBOX",
  "sandbox.detail.pageTitle": "SANDBOX",
} as const;
